<template>
  <div v-if="siteKey" class="frc-captcha-container">
    <div
      class="frc-captcha"
      :style="styles"
      :id="captchaElement"
      :data-sitekey="siteKey"
    ></div>
  </div>
</template>

<script>
import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk'

export default {
  name: 'FriendlyRecaptcha',
  props: {
    location: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      widget: null,
      styles: {
        width: '100%',
        overflow: 'unset',
        padding: 'revert-layer',
        minHeight: '50%',
        minWidth: '50%'
      }
    }
  },
  computed: {
    siteKey() {
      const sitekeyMap = {
        signup: global.ConfigDynamic.valueOf(
          global.ConfigDynamicKey.FRIENDLY_CAPTCHA_SIGNUP_SITEKEY
        ),
        login: global.ConfigDynamic.valueOf(global.ConfigDynamicKey.FRIENDLY_CAPTCHA_LOGIN_SITEKEY),
        account: global.ConfigDynamic.valueOf(
          global.ConfigDynamicKey.FRIENDLY_CAPTCHA_ACCOUNT_SITEKEY
        )
      }

      return sitekeyMap[this.location]
    },
    captchaElement() {
      return `frc-captcha-destination_${this.location}`
    }
  },
  beforeDestroy() {
    if (this.widget) {
      this.widget.removeEventListener('frc:widget.complete', this.onEmitWidgetCompleted)
      this.widget.removeEventListener('frc:widget.error', this.onEmitWidgetError)
      this.widget.removeEventListener('frc:widget.expire', this.onEmitWidgetExpire)
      this.widget.removeEventListener('frc:widget.reset', this.onEmitReset)
    }
  },
  watch: {
    siteKey: {
      immediate: true,
      handler() {
        if (this.siteKey) {
          this.createCaptcha()
        }
      }
    }
  },
  methods: {
    async createCaptcha() {
      const sdk = new FriendlyCaptchaSDK()
      await this.$nextTick()

      const captcha = document.getElementById(this.captchaElement)
      if (!captcha) {
        return
      }

      this.widget = sdk.createWidget({
        element: captcha,
        sitekey: this.siteKey
      })

      this.addEventListeners()
    },
    addEventListeners() {
      if (!this.widget) {
        return
      }

      this.$emit('reset-action', this.onResetCaptcha)
      this.widget.addEventListener('frc:widget.complete', this.onEmitWidgetCompleted)
      this.widget.addEventListener('frc:widget.error', this.onEmitWidgetError)
      this.widget.addEventListener('frc:widget.expire', this.onEmitWidgetExpire)
      this.widget.addEventListener('frc:widget.reset', this.onEmitReset)
    },
    onEmitWidgetCompleted(event) {
      this.$emit('widget-completed', event)
    },
    onEmitWidgetError() {
      this.$emit('widget-error')
      this.onResetCaptcha()
    },
    onEmitWidgetExpire() {
      this.$emit('widget-expire')
      this.onResetCaptcha()
    },
    onEmitReset() {
      this.$emit('widget-reset')
    },
    onResetCaptcha() {
      this.widget.reset()
    }
  }
}
</script>

<style scoped lang="scss">
.frc-captcha-container {
  width: 50%;
}

html[dir="rtl"] {
  .frc-captcha {
    text-align: right;
  }
}
</style>
